import request from '@/utils/request'

// crm 新建合同
export function crmContractSave(data) {
  return request({
    url: 'crm/contract/save',
    method: 'post',
    data: data
  })
}

// crm 列表
export function crmContractIndex(data) {
  return request({
    url: 'crm/contract/index',
    method: 'post',
    data: data
  })
}

// 刪除
export function crmContractDelete(data) {
  return request({
    url: 'crm/contract/delete',
    method: 'post',
    data: data
  })
}

// crm 更新
export function crmContractUpdate(data) {
  return request({
    url: 'crm/contract/update',
    method: 'post',
    data: data
  })
}

// crm 詳情
export function crmContractRead(data) {
  return request({
    url: 'crm/contract/read',
    method: 'post',
    data: data
  })
}

/**
 * 回款計劃建立
 * @param {*} data
 */
export function crmReceivablesPlanSave(data) {
  return request({
    url: 'crm/receivables_plan/save',
    method: 'post',
    data: data
  })
}

/**
 * 回款計劃編輯
 * @param {*} data
 */
export function crmReceivablesPlanUpdate(data) {
  return request({
    url: 'crm/receivables_plan/update',
    method: 'post',
    data: data
  })
}

/**
 * 合同審覈
 * @param {*} data
 * id
 * status 1通過0拒絕
 * content
 */
export function crmContractCheck(data) {
  return request({
    url: 'crm/contract/check',
    method: 'post',
    data: data
  })
}

/**
 * 合同撤回審批
 * @param {*} data
 * id
 * status 1通過 0拒絕
 * 0失敗，1通過，2撤回，3建立，4待審覈 狀態資訊
 */
export function crmContractRevokeCheck(data) {
  return request({
    url: 'crm/contract/revokeCheck',
    method: 'post',
    data: data
  })
}

/**
 * 合同相關產品
 * @param {*} data
 * contract_id
 */
export function crmContractProduct(data) {
  return request({
    url: 'crm/contract/product',
    method: 'post',
    data: data
  })
}

// 轉移
export function crmContractTransfer(data) {
  return request({
    url: 'crm/contract/transfer',
    method: 'post',
    data: data
  })
}
// 作廢
export function crmContractCancel(data) {
  return request({
    url: 'crm/contract/cancel',
    method: 'post',
    data: data
  })
}
/**
 * 合同導出
 * @param {*} data
 */
export function crmContractExcelExport(data) {
  return request({
    url: 'crm/contract/excelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}
